export default {
      id: "binoculars-usage",
      viewBox: "0 0 488.1 488.1",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#binoculars",
      toString: function () {
        return this.url;
      }
    }